<app-gmao-spinner *ngIf="isLoading"></app-gmao-spinner>

<ng-container *ngIf="installations">
    <br>
    <div>
        <button class="btnAdial btn btn-primary"><a routerLink="/incidents">Voir le suivi</a></button>
    </div>
    <br>

    <h2>Incidents</h2>
    <div class="view-item" style="text-align: center;">
        <p><strong>{{total}} messages</strong></p>
    </div>
    <div class="wrapper shadowed">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">

            <h4>Filtrer par date de mise en service du distributeur</h4>
            <br>
            <div class="paragraphe">
                <mat-form-field>
                    <input matInput [matDatepicker]="picker" placeholder="Date de début" formControlName="startDate">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker startView="year"></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <input matInput [matDatepicker]="picker1" placeholder="Date de fin" formControlName="endDate">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1 startView="year"></mat-datepicker>
                </mat-form-field>
                <button type="submit" class="btn btn-primary" style="margin-left: 40px;">Valider</button>
            </div>

        </form>
    </div>



    <div class="accordion wrapper shadowed" id="accordionIncidents">
        <div class="card">

            <div class="card-header" id="machinesSousGarantieHeader">
                <button class="btn btn-link btn-block text-left btn1" type="button" data-toggle="collapse"
                    data-target="#machinesSousGarantieCollapse" aria-expanded="true"
                    aria-controls="machinesSousGarantieCollapse">Machines sous garantie</button>
            </div>

            <div id="machinesSousGarantieCollapse" class="panel-collapse collapse"
                aria-labelledby="machinesSousGarantieHeader" data-parent="#accordionIncidents">
                <div class="card-body row">
                    <ng-container *ngFor="let installation of installations">
                        <div class="test col-sm-3"
                            *ngIf="installation.nom_contrat_sav=='Garantie' || installation.nom_contrat_sav=='Extension de Garantie 1 An' ">
                            <div class="incident-warranty incident-item">
                                <p> {{ shortInstallationName(installation.nom_installation) }}</p>
                                <p *ngFor="let panne of installation.rg_pannes_non_traitees_headers; first as isFirst">
                                    <span *ngIf="isFirst">{{convertDate(panne.date_panne)}}</span>
                                </p>
                                <hr>
                                <div class="incident-body">
                                    <div>

                                        <p>{{ installation.rg_pannes_non_traitees_headers[0].sujet }}</p> <br>

                                    </div>
                                    <div class="voirPannes">
                                        <a [routerLink]="['/installation', installation.id_installation]"> Voir
                                            toutes les pannes ({{ installation.rg_pannes_non_traitees_headers.length }}
                                            NT)</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </ng-container>

                </div>
            </div>

        </div>



        <div class="card">

            <div class="card-header" id="machinesSousContratHeader">
                <button class="btn btn-link btn-block text-left btn1" type="button" data-toggle="collapse"
                    data-target="#machinesSousContratCollapse" aria-expanded="true"
                    aria-controls="machinesSousContratCollapse">Machines sous contrat 7/7</button>
            </div>

            <div id="machinesSousContratCollapse" class="panel-collapse collapse"
                aria-labelledby="machinesSousContratHeader" data-parent="#accordionIncidents">
                <div class="card-body row">
                    <ng-container *ngFor="let installation of installations">
                        <div class="test col-sm-3"
                            *ngIf="installation.nom_contrat_sav!='Garantie' && installation.nom_contrat_sav!='Extension de Garantie 1 An'&& installation.nom_contrat_sav!='' ">
                            <div class="incident-contract incident-item">
                                <p>{{ shortInstallationName(installation.nom_installation) }}</p>
                                <p *ngFor="let panne of installation.rg_pannes_non_traitees_headers; first as isFirst">
                                    <span *ngIf="isFirst">{{convertDate(panne.date_panne)}}</span>
                                </p>
                                <hr>
                                <div class="incident-body">
                                    <div>
                                        <p>{{ installation.rg_pannes_non_traitees_headers[0].sujet }}</p> <br>
                                    </div>
                                    <div class="voirPannes">
                                        <a [routerLink]="['/installation', installation.id_installation]"> Voir
                                            toutes les pannes ({{ installation.rg_pannes_non_traitees_headers.length }}
                                            NT)</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                </div>
            </div>

        </div>

        <div class="card">

            <div class="card-header" id="autresMachinesHeader">
                <button class="btn btn-link btn-block text-left btn1" type="button" data-toggle="collapse"
                    data-target="#autresMachinesCollapse" aria-expanded="true"
                    aria-controls="autresMachinesCollapse">Autres machines</button>
            </div>


            <div id="autresMachinesCollapse" class="panel-collapse collapse" aria-labelledby="autresMachinesHeader"
                data-parent="#accordionIncidents">
                <div class="card-body row">
                    <ng-container *ngFor="let installation of installations">
                        <div class="test col-sm-3" *ngIf="installation.nom_contrat_sav=='' ">
                            <div class="incident-item incident-other">
                                <p> {{shortInstallationName(installation.nom_installation)}}</p>
                                <p *ngFor="let panne of installation.rg_pannes_non_traitees_headers; first as isFirst">
                                    <span *ngIf="isFirst">{{convertDate(panne.date_panne)}}</span>
                                </p>
                                <hr>
                                <div class="incident-body">
                                    <div>
                                        <p>{{ installation.rg_pannes_non_traitees_headers[0].sujet }}</p> <br>
                                    </div>
                                    <div class="voirPannes">
                                        <a [routerLink]="['/installation', installation.id_installation]"> Voir
                                            toutes les pannes ({{ installation.rg_pannes_non_traitees_headers.length }}
                                            NT)</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                </div>
            </div>
        </div>
    </div>
</ng-container>